export default __webpack_public_path__ + "static/media/card-image2.2d830935.png";